/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";

// Material Kit 2 React example components
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import SimpleFooter from "examples/Footers/SimpleFooter";

// Material Kit 2 React page layout routes
import routes from "routes";

// Images
import brandImage from "assets/images/brand_dark.png";

import KakaoIcon from "assets/images/kakao_icon.png";
import NaverIcon from "assets/images/naver_icon.png";
import AuthService from "services/AuthService";
import { useEffect, useState } from "react";
import config from "../../../config";
import { toast } from "react-toastify";
import { useMst } from "../../../models";
import { getItem } from "utils/localstorage";

const SignInBasic = () => {
  const { user } = useMst();

  const navigate = useNavigate();

  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [mode, setMode] = useState("login");

  useEffect(() => {
    const accessToken = getItem("access-token");
    if (accessToken) {
      navigate("/intro");
    }
  }, []);

  const loginHandler = () => {
    console.log("login", userId, password);
    AuthService.login({
      userId: userId,
      password: password,
    }).then((res) => {
      console.log("login", res);
      if (res.code === 200 && res.data?.id) {
        AuthService.authMe().then((res) => {
          console.log("me", res);
          if (res?.code === 200 && res?.data?.id) {
            user.setData(res.data);
            toast.success("로그인에 성공하였습니다.");
            navigate("/team");
          }
        });
      } else {
        toast.error("로그인에 실패하였습니다.");
      }
    });
  };

  return (
    <>
      <DefaultNavbar
        brandImage={brandImage}
        routes={[]}
        action={[]}
        transparent={false}
        center
      />
      <MKBox position="absolute" top={0} left={0} zIndex={1} width="100%" minHeight="100vh" />
      <MKBox px={1} width="100%" height="100vh" mx="auto" position="relative" zIndex={2}>

      </MKBox>
      <MKBox width="100%" position="absolute" zIndex={2} bottom="1.625rem">
        <SimpleFooter />
      </MKBox>
    </>
  );
};

export default SignInBasic;
